import {
  CART_CHECKOUT_BUTTON_CLICK,
  CART_REMOVE_PRODUCT_CLICK,
  NOW_CART_COLLAPSIBLE_CHANGE_ZIPCODE_BTN_CLICK,
  NOW_CART_COLLAPSIBLE_CHECK_ELIGIBILITY_BTN_CLICK,
  NOW_CART_GO_CHECKOUT_BTN_CLICK,
  NOW_CART_LABEL_CLICK,
} from 'shared/experiments/consts/events'
import trackEvent from 'shared/experiments/utils/trackOptimizelyEvent'
import { subscribe } from 'shared/store'
import { DELETE_CART_ITEM_SUCCESS } from 'shared/store/ducks/cart/types.consts'
import { NOW_DATA_KEY } from 'shared/store/helper/consts'
import { SPA_CART } from 'views/consts'

const handleCartTracking = () => {
  const nowMoreInfoOnProductLink = document.getElementById(SPA_CART)
  nowMoreInfoOnProductLink?.addEventListener('click', ev => {
    const nowDataString = localStorage.getItem(NOW_DATA_KEY)
    const nowData = nowDataString ? JSON.parse(nowDataString) : null

    const target = ev.target as HTMLElement

    if (target.closest('#ToCheckoutTop') || target.closest('#ToCheckout')) {
      if (nowData?.nowEligible === true) {
        trackEvent(NOW_CART_GO_CHECKOUT_BTN_CLICK)
        return
      }
    }

    if (
      target.closest(
        '[id="check-now-eligibility-not-in-delivery-region-button"]'
      )
    ) {
      trackEvent(NOW_CART_COLLAPSIBLE_CHANGE_ZIPCODE_BTN_CLICK)
    }

    if (target.closest('[id="check-now-eligibility-button"]')) {
      trackEvent(NOW_CART_COLLAPSIBLE_CHECK_ELIGIBILITY_BTN_CLICK)
    }
  })

  const productInfoElements = document.getElementsByClassName('o-ProductInfo')

  for (const el of productInfoElements) {
    el.addEventListener('click', ev => {
      const target = ev.target as HTMLElement

      if (target.closest('[data-clientside-hook~="open-now-shipping-modal"]')) {
        trackEvent(NOW_CART_LABEL_CLICK)
      }
    })
  }

  const toCheckoutButtonBottom = document.getElementById('ToCheckout')
  const toCheckoutButtonTop = document.getElementById('ToCheckoutTop')

  toCheckoutButtonBottom?.addEventListener('click', () => {
    trackEvent(CART_CHECKOUT_BUTTON_CLICK)
  })

  toCheckoutButtonTop?.addEventListener('click', () => {
    trackEvent(CART_CHECKOUT_BUTTON_CLICK)
  })

  subscribe.after(DELETE_CART_ITEM_SUCCESS, () => {
    trackEvent(CART_REMOVE_PRODUCT_CLICK)
  })
}

export default handleCartTracking
